import { createLfpGame, addLfpGameMatch, fetchLfpGame } from '../../../entities/lfpGame';

export const scope = 'LFP_GAME_UPDATE';
export const RESET_UPDATE_LFP_GAME = 'RESET_UPDATE_LFP_GAME';

export function updateLfpGameIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.lfpGame.update;
        const { day, end, start } = payload;

        if (!widget.info.isFetching)
            dispatch(createLfpGame({ day, end, start }, scope));
    };
}

export function addLfpGameMatchesIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.lfpGame.update;

        if (!widget.info.isFetching)
            dispatch(addLfpGameMatch(payload, scope));
    };
}

export function fetchLfpGameIfNeeded(payload) {
    return (dispatch, getState) => {
        const widget = getState().app.onSite.lfpGame.update;

        if (!widget.info.isFetching)
            dispatch(fetchLfpGame(payload, scope));
    };
}

export function resetUpdateLfpGame() {
    return { type: RESET_UPDATE_LFP_GAME, scope }
}




// WEBPACK FOOTER //
// ./src/actions/app/onSite/lfpGame/update.js